The code of the status of the underlying process.

Currently, the following status codes are defined:

- `AgencyShortlist`
- `AgencySubmission`
- `Application`
- `HirerShortlist`
- `Interview`
- `Offer`
- `ReferenceCheck`
- `Successful`
- `TestingOrQualificationsCheck`
- `Unsuccessful`
